import React,{Component} from 'react';
import { BrowserRouter as Router, Link  } from 'react-router-dom';

class Categories extends Component{
    

          
    render() {

        return (
            <tr>
                <td className="text-center">{this.props.details.category}</td>
                <td className="text-center">
                    <div className="btn-group btn-group-xs">
                        <Link to={`category/${this.props.index}/edit`} data-toggle="tooltip" className="btn btn-default"> <i className="fa fa-pencil"></i></Link>
                        <button className="btn btn-xs btn-danger" type="submit" onClick={()=>this.props.removeCategory(this.props.index)}><i className="fa fa-times"></i></button> 
                    </div>
                </td>
            </tr>
        );
    }
}

export default  Categories;



// WEBPACK FOOTER //
// ./src/components/Categories.js